<template>
    <v-navigation-drawer app clipped :value="pDrawer" :mini-variant.sync="mini" width="15vw">
        <div class="flex-column fill-height" style="position: relative;">
            <div class="flex-grow-1">
                        <!-- Espacio para AppBar -->
                <v-toolbar flat height="80" class="d-lg-none"></v-toolbar>
                <div style="height: 120px;" class="pa-2 d-flex flex-column justify-center">
                    <v-fade-transition mode="out-in">
                        <div v-if="activeHeader" :key="activeHeader.title">
                            <div class="d-flex align-center mb-0 header-logo-container">
                                <v-img :src="getThemeImage('logo_flor3')"
                                class="header-logo"
                                contain/>
                                <h2 class="text-h6 font-weight-bold white--text" v-if="!mini"> <!--Si requiero truncar el texto, solo agregar: text-truncate-->
                                    {{ activeHeader.title }}
                                </h2>
                            </div>
                            <p class="caption grey--text text--lighten-2 mb-0" style=" -webkit-box-orient: vertical; overflow: hidden; line-height: 1.2rem; margin-left: 60px;" v-if="!mini">
                                {{ activeHeader.subtitle }}
                            </p>
                        </div>
                    </v-fade-transition>
                </div>
                <v-list>
                    <v-list-item-group v-model="currentFilter">
                        <v-list-item link :to="{ name: 'processes'}" :value="FILTER_STATUS_NEW" @click="filterProceduresList(FILTER_STATUS_NEW)">
                            <v-list-item-action>
                                <v-icon color="main_color_itens">
                                    mdi-plus
                                </v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>Nuevo trámite</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item @click="filterProceduresList(FILTER_STATUS_ALL)" :value="FILTER_STATUS_ALL" :key="FILTER_STATUS_ALL" >
                            <v-list-item-action>
                                <v-icon color="main_color_itens">
                                    mdi-file-document-outline
                                </v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>Todos mis trámites</v-list-item-title>
                            </v-list-item-content>
                            <!--<v-list-item-action>
                                <div class="menu-counter">
                                    20
                                </div>
                            </v-list-item-action>-->
                        </v-list-item>
                        <v-list-item @click="filterProceduresList(FILTER_STATUS_ACTIVE)" :value="FILTER_STATUS_ACTIVE" :key="FILTER_STATUS_ACTIVE">
                            <v-list-item-action>
                                <v-icon color="main_color_itens">
                                    mdi-alarm
                                </v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>Pendientes</v-list-item-title>
                            </v-list-item-content>
                            <!--<v-list-item-action>
                                <div class="menu-counter">
                                    20
                                </div>
                            </v-list-item-action>-->
                        </v-list-item>
                        <v-list-item @click="filterProceduresList(FILTER_STATUS_IN_PROCESS)" :value="FILTER_STATUS_IN_PROCESS" :key="FILTER_STATUS_IN_PROCESS">
                            <v-list-item-action>
                                <v-icon color="main_color_itens">
                                    mdi-chart-line-variant
                                </v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>En proceso</v-list-item-title>
                            </v-list-item-content>
                            <!--<v-list-item-action>
                                <div class="menu-counter">
                                    20
                                </div>
                            </v-list-item-action>-->
                        </v-list-item>
                        <v-list-item link @click="filterProceduresList(FILTER_STATUS_FINISHED)" :value="FILTER_STATUS_FINISHED" :key="FILTER_STATUS_FINISHED">
                            <v-list-item-action>
                                <v-icon color="main_color_itens">
                                    mdi-check-circle-outline
                                </v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>Completados</v-list-item-title>
                            </v-list-item-content>
                            <!--<v-list-item-action>
                                <div class="menu-counter">
                                    20
                                </div>
                            </v-list-item-action>-->
                        </v-list-item>
                        <v-list-item link @click="filterProceduresList(FILTER_STATUS_CANCELED)" :value="FILTER_STATUS_CANCELED" :key="FILTER_STATUS_CANCELED">
                            <v-list-item-action>
                                <v-icon color="main_color_itens">
                                    mdi-close-circle-outline
                                </v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>Cancelados</v-list-item-title>
                            </v-list-item-content>
                            <!--<v-list-item-action>
                                <div class="menu-counter">
                                    20
                                </div>
                            </v-list-item-action>-->
                        </v-list-item>
                        <v-list-item link :to="{ name: 'orders', params: {action: 'list'} }" :value="FILTER_STATUS_ORDER" @click="filterProceduresList(FILTER_STATUS_ORDER)">
                            <v-list-item-action>
                                <v-icon color="main_color_itens">
                                    mdi-list-box-outline
                                </v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>Mis órdenes</v-list-item-title>
                            </v-list-item-content>
                            <!--<v-list-item-action>
                                <div class="menu-counter">
                                    20
                                </div>
                            </v-list-item-action>-->
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
            </div>
            <div class="pa-2">
                <v-btn block @click.stop="mini = !mini" class="btn-toggle-sidebar" text>
                    <v-icon color="main_color_itens">{{ mini ? 'mdi-menu' : 'mdi-menu-open' }}</v-icon>
                </v-btn>
            </div>
            <v-img :src="getThemeImage('logo_flor2')"
                class="logo-background-fixed"
                contain/>
        </div>
    </v-navigation-drawer>
</template>

<script>
    import {mapState, mapActions} from 'vuex';
    import router from "../config/router";
    import vClickOutside from 'v-click-outside'
    
    import {procedureListRequest} from "../api/models";
import { Handler, icon } from 'leaflet';

    export default {
        props: ['pDrawer'],
        data(){
            return {
                currentFilter: -1,
                FILTER_STATUS_ALL: 0,
                FILTER_STATUS_ACTIVE: 1,
                FILTER_STATUS_FINISHED: 2,
                FILTER_STATUS_CANCELED: 3,
                FILTER_STATUS_IN_PROCESS: 5,
                FILTER_STATUS_DELETED: 4,
                FILTER_STATUS_ORDER: 6,
                FILTER_STATUS_NEW: 7,
                drawer: this.pDrawer,
                mini: false,
                lastValidHeader: {
                    title: 'Nuevo trámite',
                    subtitle: 'Selecciona el trámite que quieres realizar',
                    icon: 'mdi-plus'
                },
            }
        },

        computed: {
            ...mapState({accountStore: state => state.account, proceduresStore: state => state.procedures}),
            getThemeImage() {
                return (key) => {
                    const themeIcons = this.$vuetify.theme.themes.light?.icons;
                    if (!themeIcons || !themeIcons[key]) {
                        console.warn(` La clave "${key}" no existe en los iconos del tema.`);
                        return ""; // Retorna una imagen vacía en caso de error
                    }

                    const path = themeIcons[key];

                    try {
                        return require(`@/assets/${path}`);
                    } catch (error) {
                        console.error(` Error al cargar la imagen: ${path}`, error);
                        return "";
                    }
                };
            },
            activeHeader() {
                return this.lastValidHeader;
            },
        },

        mounted() {
            this.currentFilter = this.proceduresStore.filterStatus
        },

        methods: {
            ...mapActions('procedures', ['getProceduresByUser']),
            filterProceduresList(filterStatus) {
                this.currentFilter = filterStatus

                if (filterStatus < 6 && router.currentRoute.name !== 'process'){
                    router.push({name: 'process'})
                }

                if (filterStatus !== this.proceduresStore.filterStatus) {
                    let request = procedureListRequest()
                    request.userId = this.accountStore.user.id
                    request.status = filterStatus
                    request.limit = this.proceduresStore.pageLimit

                    this.getProceduresByUser(request)
                }
            },
        },
        watch: {
            pDrawer(val) {
                this.drawer = val

            },
            currentFilter: {
                immediate: true,
                handler(newVal){
                    // Mapeo de información según el filtro seleccionado
                    const headerMap = {
                        [this.FILTER_STATUS_NEW]: {
                            title: 'Nuevo trámite',
                            subtitle: 'Seleccione el trámite que quieres realizar',
                            icon: 'mdi-plus'
                        },
                        [this.FILTER_STATUS_ALL]: {
                            title: 'Todos mis trámites',
                            subtitle: 'Búsqueda y gestión de trámites',
                            icon: 'mdi-file-document-outline'
                        },
                        [this.FILTER_STATUS_ACTIVE]: {
                            title: 'Pendientes',
                            subtitle: 'Gestiones que requieren tu atención',
                            icon: 'mdi-alarm'
                        },
                        [this.FILTER_STATUS_IN_PROCESS]: {
                            title: 'En Proceso',
                            subtitle: 'Estamos revisando tu solicitud',
                            icon: 'mdi-chart-line-variant'
                        },
                        [this.FILTER_STATUS_FINISHED]: {
                            title: 'Completados',
                            subtitle: 'Listado completo de trámites completos',
                            icon: 'mdi-check-circle-outline'
                        },
                        [this.FILTER_STATUS_CANCELED]: {
                            title: 'Cancelados',
                            subtitle: 'Listado de trámites cancelados',
                            icon: 'mdi-close-circle-outline'
                        },
                        [this.FILTER_STATUS_ORDER]: {
                            title: 'Mis órdenes',
                            subtitle: 'Revisión de órdenes',
                            icon: 'mdi-list-box-outline'
                        },
                    };
                    if(headerMap[newVal]) {
                        this.lastValidHeader = headerMap[newVal];
                    }
                }
            },
            directives: {
                clickOutside: vClickOutside.directive
            }
        }    
    }
    
</script>

<style scoped>
    @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;700&display=swap');
    .ico_drawer_item{
        width: 24px;
        height: 24px;
    }
    
    .ico_menu{
        background-image: url("../assets/img/menu.png");
        background-size: cover;
        display: inline-block;
        position: relative;
        text-align: right;
        top: 10px;
        left: 215px;
        width: 24px;
        height: 24px;
    }

    .v-navigation-drawer--mini-variant .ico_menu{
        transform: translateX(-200px);
        transition: 0.2s ease-in-out;
    }

    .v-navigation-drawer .v-list-item--active .v-icon {
        background: rgba(255,255,255,0.2);
        padding: 3px;
        border-radius: 9px;
        border: 1px solid rgba(255,255,255,0.2);
    }

    /* Drawer items estilo pill */
    .v-navigation-drawer .v-list-item--active {
        background-color: #12312B !important; /* verde oscuro */
        border: 1px solid rgba(255,255,255,0.2);
        border-radius: 15px;
        margin: 2px 4px;
    }

    /*Quitamos el overlay para que no se encime el color que pone por defecto vuetify*/
    .v-navigation-drawer .v-list-item--active::before {
        display: none !important;
    }

    .v-navigation-drawer{
        font-family: 'Montserrat', sans-serif !important;
        background: v-bind($vuetify.theme.themes.light.bg_navbar_) !important ;

    }

    .v-navigation-drawer .v-list-item__title {
        font-size: 14px !important;
        color: v-bind($vuetify.theme.themes.light.txt_color_nav) !important ;
    }

    .v-navigation-drawer .v-list-item{
        margin-bottom: 8px !important;
    }

    .v-list-item {
      color: v-bind($vuetify.theme.themes.light.txt_color_nav) !important ;
    }
    .v-navigation-drawer .v-list-item__content{
        margin-left: -20px !important;
        font-weight: 600 !important;
    }
    .v-fade-transition, 
    .text-h6, 
    .caption {
        font-family: 'Montserrat', sans-serif !important;
        margin-left: 15px;
    }

    .menu-counter {
        background-color: rgba(255, 255, 255, 0.1); 
        border: 1px solid rgba(255, 255, 255, 0.2); 
        border-radius: 9px;                        
        color: white;                            
        font-size: 12px;                            
        font-family: 'Montserrat', sans-serif;      
        font-weight: 600;
        min-width: 33px;                            
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

/*--------------------------------------------------------------------------------------------------------------------------------*/
    /* En caso de hacerlo dinamico y el número autoincremente con data, usar esta lógica para el JS*/
    /*data() {
        return {
            counts: {
                all: 20,
                pending: 5,
                process: 12,
                // ...
            }
        }
    }*/
/*--------------------------------------------------------------------------------------------------------------------------------*/
    /* .v-navigation-drawer{
        top: 64px !important;
    }
 */

.btn-toggle-sidebar {
    border-radius: 8px !important;
}

.btn-toggle-sidebar:hover {
    background-color: rgba(255, 255, 255, 0.2) !important;
}

.v-navigation-drawer--mini-variant {
    width: 8% !important;
    overflow: hidden;
}

.v-navigation-drawer--mini-variant .v-list-item__action {
    margin: 0 !important;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100% !important;
}

.v-navigation-drawer--mini-variant .header-logo-container {
    
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100% !important;
}

.v-navigation-drawer--mini-variant .btn-toggle-sidebar {
    width: 50px !important;
    margin: 0 auto;
    display: block;
}

.logo-background-fixed {
    position: absolute !important;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 250px;
    pointer-events: none;
    z-index: 1;
}

.header-logo-container {
    height: 40px;
}

.header-logo {
    max-width: 45px;
    max-height: 45px;
}

</style>